function convertDateFormat(dateStr) {
  const [datePart, timePart] = dateStr.split(' ')
  const [year, month, day] = datePart.split('-')
  const [hour, minute] = timePart.split(':')

  return `${year}${month}${day}T${hour}${minute}00`
}

export const getCalendarLink = (content) => {
  if (!content) return null

  const { title, location, startDate, endDate, details, type } = content
  if (!startDate || !endDate || !title) return null

  const start = convertDateFormat(startDate)
  const end = convertDateFormat(endDate)

  if (type === 'google') {
    return `https://calendar.google.com/calendar/u/0/r/eventedit?text=${title}&dates=${start}/${end}&details=${details}&location=${location}&ctz=America/Los_Angeles`
  }

  return `data:text/calendar;charset=utf8,BEGIN:VCALENDAR%0AVERSION:2.0%0ABEGIN:VEVENT%0ASUMMARY:${title}%0ADESCRIPTION:${details}%0ADTSTART;TZID=America/Los_Angeles:${start}%0ADTEND;TZID=America/Los_Angeles:${end}%0ALOCATION:${location}%0AEND:VEVENT%0AEND:VCALENDAR`
}
